import { getArchives, toggleFavorite, toggleMarkDelete } from "@/api/archives";
import Vue from "vue";

const state = {
  list: [],
  recentBuilds: [],
  pagination: {
    total: 0,
    page: 1,
    page_size: 20,
    pages: 0,
  },
};

const mutations = {
  SET_LIST(state, { items, total, page, page_size, pages }) {
    state.list = items;
    state.pagination = { total, page, page_size, pages };
  },
  SET_FAVORITES(state, { items, total, page, page_size, pages }) {
    state.list = items;
    state.pagination = { total, page, page_size, pages };
  },
  SET_RECENT_BUILDS(state, { items }) {
    state.recentBuilds = items;
  },
  UPDATE_ITEM(state, updated) {
    const idx = state.list.findIndex((i) => i.id === updated.id);
    if (idx !== -1) Vue.set(state.list, idx, updated);
  },
  REMOVE_ITEM(state, id) {
    state.list = state.list.filter((item) => item.id !== id);
  },
};

const actions = {
  async getArchives({ commit }, payload) {
    try {
      const response = await getArchives(payload);
      commit("SET_LIST", response);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async getRecentBuilds({ commit }, payload = {}) {
    try {
      const response = await getArchives({
        ...payload,
        page: 1,
        page_size: 10,
      });
      commit("SET_RECENT_BUILDS", response);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async getFavorites({ commit }, payload) {
    try {
      const response = await getArchives(payload);
      commit("SET_FAVORITES", response);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async toggleFavorite({ commit }, id) {
    try {
      const updated = await toggleFavorite(id);
      commit("UPDATE_ITEM", updated);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async removeFavorite({ commit }, id) {
    try {
      await toggleFavorite(id);
      commit("REMOVE_ITEM", id);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
  async toggleMarkDelete({ commit }, id) {
    try {
      const updated = await toggleMarkDelete(id);
      commit("UPDATE_ITEM", updated);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
